// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

export default class SubmenuToggle extends WebComponent {
  didMount() {
    this.on('click', () => {
      const trigger = this.element;
      const subMenu = trigger.nextElementSibling;
      subMenu.classList.toggle('active');
    });
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/SubmenuToggle.js